import { FormEvent, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthShell, Field, FormError } from "@/components/auth/AuthShell";
import { ApiError } from "@/api/client";
import { api } from "@/api/endpoints";
import { useSession } from "@/store/session";

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const setSession = useSession((s) => s.setSession);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const returnTo = (location.state as { returnTo?: string } | null)?.returnTo ?? "/chat";

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr("");
    if (!email.includes("@")) return setErr("Please enter a valid email address.");
    if (password.length < 8) return setErr("Password must be at least 8 characters.");
    setBusy(true);
    try {
      const res = await api.auth.login({ email: email.trim().toLowerCase(), password });
      setSession(res);
      navigate(returnTo, { replace: true });
    } catch (e) {
      if (e instanceof ApiError) {
        setErr(e.status === 401 ? "Invalid email or password." : e.message);
      } else {
        setErr("Something went wrong. Please try again.");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell kicker="Sign in" title="Welcome back.">
      <form onSubmit={submit}>
        <Field
          label="Email"
          type="email"
          value={email}
          onChange={setEmail}
          placeholder="you@example.com"
          autoComplete="email"
          autoFocus
        />
        <Field
          label="Password"
          type="password"
          value={password}
          onChange={setPassword}
          placeholder="••••••••"
          autoComplete="current-password"
        />
        {err && <FormError message={err} />}
        <button
          type="submit"
          className="sa-btn"
          style={{ width: "100%", padding: "12px 18px" }}
          disabled={busy}
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <hr className="sa-hair" style={{ margin: "28px 0" }} />
      <div
        style={{
          fontFamily: "var(--sa-sans)",
          fontSize: 13,
          color: "var(--sa-muted-fg)",
          textAlign: "center",
        }}
      >
        Don't have an account?{" "}
        <Link
          to="/register"
          style={{
            color: "var(--sa-accent)",
            textDecoration: "underline",
            textUnderlineOffset: 3,
          }}
        >
          Create one
        </Link>
      </div>
    </AuthShell>
  );
}
